import { Component, OnInit } from '@angular/core';
import {GeneralClairvoyantComponent} from '../g-clairvoyant.component';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from '../topic.service';
import {MessageService} from '../../shared/message.service';

@Component({
  selector: 'app-clairvoyant-change-two-player',
  templateUrl: './clairvoyant-change-two-player.component.html',
  styleUrls: ['./clairvoyant-change-two-player.component.css']
})
export class ClairvoyantChangeTwoPlayerComponent extends GeneralClairvoyantComponent {

  readyForClairvoyant = false;
  solution: number[] = [];
  helperSolution: boolean[][] = [];
  clickedValue: number[] = [];
  isLeaved: boolean;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
  }

  initValues() {
    super.initValues();
    this.isLeaved = false;
    this.helperSolution = [];
    this.clickedValue = [];
    this.readyForClairvoyant = false;
  }

  checkSolution() {
    // if solution correct, generate new exercise
    if (this.compareArrays(this.clickedValue, this.solution)) {
      this.solution = [];
      this.messageService.addAlertWithTimeout(this.get('correctlyDecoded'), 'success', 1000);
      this.isSolvedImageVisible = true;
      this.solved = true;
      setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
      this.saveState();
    } else {
      this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
    }
  }

  checkHelperSolution() {
    let countOpenCardsRow = 0;
    let countOpenCardsColumn = 0;
    for (let i = 0; i < this.helperSolution.length; i++) {
      countOpenCardsRow = 0;
      countOpenCardsColumn = 0;
      for (let j = 0; j < this.helperSolution.length; j++) {
        if (this.helperSolution[i][j]) {
          countOpenCardsRow++;
        }
        if (this.helperSolution[j][i]) {
          countOpenCardsColumn++;
        }
      }
      if (countOpenCardsRow % 2 !== 0 || countOpenCardsColumn % 2 !== 0) {
        this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 1000);
        return false;
      }
    }
    this.readyForClairvoyant = true;
    return true;
  }

  setSolution(solution: number[]) {
    this.solution = solution;
  }

  setClickedValue(valueIdx: number[]) {
    this.clickedValue = valueIdx;
    this.checkSolution();
  }

  setHelperSolution(solution: boolean[][]) {
    this.helperSolution = solution;
  }

  setLeaveRoom(isLeaved: boolean) {
    this.isLeaved = isLeaved;
  }

}
